import { TEMPLATE_RENDERED, HIDE_TRANSPORT_OVERLAY, TOGGLE_TRANSPORT_OVERLAY, SHOW_TRANSPORT_OVERLAY, TRANSPORT_OVERLAY_ACTIVE_QUEUES, TRANSPORT_OVERLAY_PLAY_QUEUE } from '../actions';
import { BUFFER, CLEAR, PAUSED, PLAY, PLAY_NEXT, PLAY_PREVIOUS, PLAYBACK_NOT_SUPPORTED, PLAYBACK_TOGGLE, RESUMED, SCRUBBED, SET_VOLUME, TRIGGER_PLAY_QUEUE, CHANGE_VOLUME, TRIGGER_ACTIVE_QUEUES } from '../actions/Playback';
import { getInstance, isEMESupported, setPlayerConfig } from '../player';
import { globals } from '../utils';
import { dispatchPlaybackMethods } from '../utils/dispatchPlaybackMethods';
import { reportFlexEvent } from '../utils/reportFlexEvent';
let player;
export const PlaybackMiddleware = (store) => (nextAction) => async (action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (URLSearchParams && (new URLSearchParams(location.search)).get('debug') === 'true') {
        // tslint:disable-next-line:no-console
        console.log(action.type, action.payload, (new Date).toTimeString());
    }
    const auth = store.getState().Authentication;
    const onPlaybackNotSupported = store.getState().Media.onPlaybackNotSupported;
    const { activeQueues } = store.getState().PlaybackStates;
    const TransportOverlayState = store.getState().TransportOverlay;
    let actionType;
    // tslint:disable-next-line:switch-default
    switch (action.type) {
        case TEMPLATE_RENDERED:
            try {
                await isEMESupported();
                player = await getInstance();
                setPlayerConfig(player, auth);
            }
            catch (_s) {
                break;
            }
            break;
        case BUFFER:
            try {
                await isEMESupported();
                player = await getInstance();
                setPlayerConfig(player, auth);
                player.load(action.payload.audioUri);
            }
            catch (_t) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, onPlaybackNotSupported);
                const { UAParser } = await import(/* webpackChunkName: "metrics" */ 'ua-parser-js');
                const ua = new UAParser(globals.navigator.userAgent);
                reportFlexEvent(`WebPlayerMaestroNotSupported`, [['', ua.getOS().name, ua.getBrowser().name, ua.getBrowser().major], []], store.getState().Authentication);
            }
            break;
        case PLAYBACK_TOGGLE:
            const { play } = store.getState().PlaybackStates;
            if (!play) {
                break;
            }
            if (play.isDisabled) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, play.onDisabledPlayControlSelected);
            }
            else {
                if (player.isPlaying()) {
                    store.dispatch({ type: PAUSED, payload: action.payload });
                }
                else {
                    store.dispatch({ type: RESUMED, payload: action.payload });
                }
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, play.onEnabledPlayControlSelected);
            }
            break;
        case PLAY:
            try {
                await isEMESupported();
                player = await getInstance();
                player.play(action.payload.mediaId);
            }
            catch (_u) {
                store.dispatch({ type: PLAYBACK_NOT_SUPPORTED });
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, onPlaybackNotSupported);
            }
            break;
        case CLEAR:
            (_a = player) === null || _a === void 0 ? void 0 : _a.pause();
            break;
        case PAUSED:
            (_b = player) === null || _b === void 0 ? void 0 : _b.pause();
            break;
        case RESUMED:
            // For uploaded or ad content, the mediaId has the format "https://stuff.cloudfront.net/morestuff/song.mp3".
            // Maestro records this as the id: stuff.cloudfront.net/morestuff/song.mp3.
            // By using includes, we can check if the song Maestro is aware of is the same 
            // as the incoming uploaded / ad content. Includes() by default works for the 
            // equals case, so "ASIN1".includes("ASIN1") will return true.
            // Case 2: In cases like the playback indicator, we don't send a mediaId when we click play. So, 
            // we need to explicitly check for the abscence of the property to confirm this is that case. 
            if (!('mediaId' in ((_c = action) === null || _c === void 0 ? void 0 : _c.payload)) || ((_f = (_e = (_d = action) === null || _d === void 0 ? void 0 : _d.payload) === null || _e === void 0 ? void 0 : _e.mediaId) === null || _f === void 0 ? void 0 : _f.includes((_g = player) === null || _g === void 0 ? void 0 : _g.getCurrentTrackId()))) {
                (_h = player) === null || _h === void 0 ? void 0 : _h.resume();
            }
            else if (player) {
                store.dispatch({ type: PLAY, payload: action.payload });
            }
            break;
        case SCRUBBED:
            const { scrub } = store.getState().PlaybackStates;
            if (!scrub) {
                break;
            }
            if (scrub.isDisabled) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, scrub.onDisabledScrubControlSelected);
            }
            else {
                (_j = player) === null || _j === void 0 ? void 0 : _j.seekTo(action.payload.position);
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, (_k = scrub) === null || _k === void 0 ? void 0 : _k.onEnabledScrubControlSelected);
            }
            break;
        case PLAY_NEXT:
            const { next } = store.getState().PlaybackStates;
            if (!next) {
                break;
            }
            if (next.isDisabled) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, next.onDisabledNextControlSelected);
            }
            else {
                (_l = player) === null || _l === void 0 ? void 0 : _l.pause();
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, next.onEnabledNextControlSelected);
            }
            break;
        case PLAY_PREVIOUS:
            const { previous } = store.getState().PlaybackStates;
            if (!previous) {
                break;
            }
            if (previous.isDisabled) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, previous.onDisabledPreviousControlSelected);
            }
            else {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, previous.onEnabledPreviousControlSelected);
                if (((_m = player) === null || _m === void 0 ? void 0 : _m.getCurrentTime()) < 4) {
                    (_o = player) === null || _o === void 0 ? void 0 : _o.pause();
                }
                else {
                    (_p = player) === null || _p === void 0 ? void 0 : _p.seekTo(0);
                    return;
                }
            }
            break;
        case SET_VOLUME:
            player = await getInstance();
            player.volume(action.payload.volume);
            break;
        case CHANGE_VOLUME:
            const { volume } = store.getState().PlaybackStates;
            if (!volume) {
                break;
            }
            if (!((_q = volume) === null || _q === void 0 ? void 0 : _q.isDisabled)) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, volume.onEnabledVolumeControlSelected);
            }
            break;
        case TRIGGER_PLAY_QUEUE:
            const { visualPlayQueue } = store.getState().PlaybackStates;
            const { playQueue, onVisualPlayQueueDataRequired } = store.getState().Media;
            if (!visualPlayQueue) {
                break;
            }
            if ((_r = visualPlayQueue) === null || _r === void 0 ? void 0 : _r.isDisabled) {
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, visualPlayQueue.onDisabledVisualPlayQueueControlSelected);
                store.dispatch({ type: HIDE_TRANSPORT_OVERLAY });
            }
            else {
                actionType = TOGGLE_TRANSPORT_OVERLAY;
                if (TransportOverlayState.isTransportOverlayOpen && TransportOverlayState.id !== TRANSPORT_OVERLAY_PLAY_QUEUE) {
                    actionType = SHOW_TRANSPORT_OVERLAY;
                }
                dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, visualPlayQueue.onEnabledVisualPlayQueueControlSelected);
                store.dispatch({
                    type: actionType,
                    payload: {
                        id: action.payload.transportOverlayId,
                        onDataRequired: onVisualPlayQueueDataRequired,
                    }
                });
            }
            break;
        case TRIGGER_ACTIVE_QUEUES:
            if (!activeQueues) {
                break;
            }
            actionType = TOGGLE_TRANSPORT_OVERLAY;
            if (TransportOverlayState.isTransportOverlayOpen && TransportOverlayState.id !== TRANSPORT_OVERLAY_ACTIVE_QUEUES) {
                actionType = SHOW_TRANSPORT_OVERLAY;
            }
            dispatchPlaybackMethods(store.dispatch, action.payload.mediaId, activeQueues.activeDevices);
            store.dispatch({
                type: actionType,
                payload: {
                    id: action.payload.transportOverlayId,
                }
            });
            break;
    }
    nextAction(action);
};
